import { ConditionCode } from '@/shared/api/protocol-ts/model/dto_report_condition_codes_pb';
import type { Condition } from '@/shared/api/protocol-ts/model/dto_report_condition_pb';
import type { Report } from '@/shared/api/protocol-ts/model/dto_report_pb';
import type { Tooth } from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';

import { conditionIsActive } from '@/entities/condition';

import { isDeleted } from './isDeleted';
import { optionalRelationMatches } from './optionalRelationMatches';

export const isMissingConditionForTooth = ({
  condition,
  report,
  tooth,
}: {
  condition: Condition;
  report: Report;
  tooth: Tooth;
}) =>
  !isDeleted(condition) &&
  condition.ReportID === report.ID &&
  optionalRelationMatches(condition.PatientID, report.PatientID) &&
  optionalRelationMatches(condition.OrganizationID, report.OrganizationID) &&
  condition.Attribution.case === 'Tooth' &&
  condition.Attribution.value.ToothID === tooth.ID &&
  condition.Code === ConditionCode.Missing &&
  conditionIsActive(condition);
